import { Box } from '@chakra-ui/react';

import { Condition, Iteration } from 'Component/others';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import { useStockPromoState } from 'View/stock-promo/state';

import styles from './styles.module.css';

const ColumnProductPromo = ({ value, values }) => {
  const { updateState } = useStockPromoState();
  return (
    <Box className={styles['column-product-promo__container']}>
      <Condition
        statement={value && value.length > 0}
        fallback={
          <Box className={`${styles['column-product-promo__box--item']}`}>
            <TextRegular className={styles['column-product-promo__text']}>-</TextRegular>
          </Box>
        }
      >
        <Iteration
          items={value.filter((_, index) => index < 2)}
          render={(product, index) => {
            const isFirstColumn = index === 0 && value?.length > 1;
            const isHasMore = value.length > 2 && index === 1;

            return (
              <Box className={`${styles['column-product-promo__box--item']} ${isFirstColumn ? styles['column-product-promo__box--item-first'] : ''}`}>
                <TextRegular className={styles['column-product-promo__text']}>{product.name}</TextRegular>
                <Condition statement={isHasMore}>
                  <TextSemiBold
                    className={styles['column-product-promo__text--more']}
                    onClick={() => {
                      updateState({ isOpenModalDetailPromo: true, detailPromoData: values });
                    }}
                  >
                    + {value.length - 2} lainnya
                  </TextSemiBold>
                </Condition>
              </Box>
            );
          }}
        />
      </Condition>
    </Box>
  );
};

export default ColumnProductPromo;
